import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { getDuration } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/get-duration';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { CellContext } from '@tanstack/react-table';

export interface TransactionListDurationCellProps
  extends CellContext<TransactionModel, unknown> {}

export const TransactionListDurationCell = (
  props: TransactionListDurationCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Text truncate>
      {getDuration(row.original.startedAt, row.original.stoppedAt)}
    </Text>
  );
};
